import {
  useNavigate,
} from 'react-router';
import { Modal, Icon } from 'web-components';
import { Flex, Text, H200, SVG } from 'web-styled';
import {
  trackAnalyticsEvent,
} from 'web-utils';

import * as S from './styled'

type Props = {
  isOpen: boolean
  isUpgradeable: boolean
  onRequestClose: () => void
};

type Feature = {
  text: string;
  bold?: boolean;
};

const CheckIcon = ({ active }: { active: boolean }) => (
  <Flex width="28px" height="28px">
    <SVG.CheckCircleIcon
      circleStroke={active ? '#0074D9' : '#D9D9D9'}
      circleFill={active ? '#0074D9' : '#D9D9D9'}
      checkStroke={active ? '#ffffff' : '#0074D9'}
    />
  </Flex>
);

const FeatureItem = ({ text, active = false }: { text: string; active?: boolean }) => (
  <Flex align="center" spacing={10}>
    <CheckIcon active={active} />
    <Text size="16px" color="#121827" dangerouslySetInnerHTML={{ __html: text }} />
  </Flex>
);

const freeFeatures: Feature[] = [
  { text: 'Add unlimited clients' },
  { text: 'Get pre-loaded workout and program templates' },
  {
    text: 'Create your own library of exercises, workouts, and programs to share with your clients',
  },
];

const premiumFeatures: Feature[] = [
  { text: 'All free features plus exclusive premium features' },
  { text: 'Use <b>in-app messaging</b> for client communication' },
  { text: '<b>Schedule workouts</b> and programs' },
  { text: '<b>Track</b> client results' },
  { text: 'Manage your <b>video library</b>' },
  { text: '<b>Share documents</b> with your clients' },
];

const FeatureColumn = ({
  title,
  features,
  active,
  borderLeft = false,
  isUpgradeable,
  onUpgrade,
}: {
  title: string;
  features: Feature[];
  active: boolean;
  borderLeft?: boolean;
  isUpgradeable?: boolean
  onUpgrade?: { (): void }
}) => (
  <Flex
    column
    spacing={30}
    width="50%"
    padding="30px"
    borderLeft={borderLeft ? '1px solid #CCCCCC' : undefined}
  >
    <H200>{title}</H200>
    <Flex column spacing={24}>
      {features.map((feature, idx) => (
        <FeatureItem key={idx} text={feature.text} active={active} />
      ))}
    </Flex>
    {isUpgradeable && (
      <S.Upgrade
        onClick={onUpgrade}
      >
        Upgrade Now
      </S.Upgrade>
    )}
  </Flex>
);

const ComparePlan = ({ isOpen, isUpgradeable, onRequestClose }: Props) => {
  const navigate = useNavigate();
  return (
    <Modal
      isOpen={isOpen}
      hideHeader
      onRequestClose={onRequestClose}
      contentStyle={{ width: '900px', borderRadius: '30px' }}
    >
      <S.Close onClick={onRequestClose}>
        <Icon
          type="fas fa-times"
        />
      </S.Close>
      <Flex>
        <FeatureColumn
          title="Program Builder"
          features={freeFeatures}
          active={false}
        />
        <FeatureColumn
          title="Program Builder +"
          features={premiumFeatures}
          active={true}
          borderLeft
          isUpgradeable={isUpgradeable}
          onUpgrade={() => {
            trackAnalyticsEvent('clicked_upgrade_plan')
            navigate('/payments/details')
            onRequestClose()
          }}
        />
      </Flex>
    </Modal>
  )
};

export default ComparePlan;
